import {useEffect, useState} from "react";
import {Box, Button, Divider, Grid, LinearProgress, Paper, Typography} from "@mui/material";
import {useEvents} from "./DanceEventProvider.jsx";
import {EventCardCompact} from "./EventCardCompact.jsx";
import {sliceIn2} from "../shared/transform.js";
import {dateStrToDateObj, dateToHumanDateStr, nextDateStr, prevDateStr, sixWeeks, today} from "../shared/date.js";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import {DateCalendar} from "@mui/x-date-pickers/DateCalendar";
import {AddEventButton} from "./Button/AddEventButton.jsx";


const DayCalendar = (props) => {

    const [date, setDate] = useState(props.date)
    const dateObj = dateStrToDateObj(date)
    const dateStr = dateToHumanDateStr(dateObj)
    const next = nextDateStr(date)
    const prev = prevDateStr(date)
    const {loading, events} = useEvents()
    const [displayCalendar, setDisplayCalendar] = useState(false)
    const [loadedEvents, setLoadedEvents] = useState([]); // <-- new state

    useEffect(() => {
        if (date < today()) {
            // Fetch historical events for this date
            const fetchOldEvents = async () => {
                try {
                    const res = await fetch(
                        `${process.env.REACT_APP_BACKEND_HOST}/events?filters[date][$eq]=${date}&populate=*`
                    );
                    const data = await res.json();
                    setLoadedEvents(data.data || []);
                } catch (e) {
                    setLoadedEvents([]);
                }
            };
            fetchOldEvents();
        }
    }, [date]);

    if (loading) {
        return <Box height={"500px"}>
            <Typography variant={"h6"}>Loading Events...</Typography>
            <LinearProgress />
        </Box>
    }

    const filterByDay = (events, dateStr) =>  events.filter((e) => e.date === dateStr)
    const filterEvents = date >= today() ? filterByDay(events, date) : loadedEvents;

    if (!loading && filterEvents.length === 0) {
        console.debug("no mapped events", events, date)
        return <Box>No Events Found</Box>
    }

    let stickyAt = "166px"
    if (window.innerWidth < 600) {
        stickyAt = "96px"
    }

    const [events1, events2] = sliceIn2(filterEvents)

    const expansionIcon = displayCalendar ? <ExpandLessIcon /> : <ExpandMoreIcon/>

    return <Grid container spacing={1}>
        <Grid item xs={12} style={{position: "sticky", top: stickyAt,  zIndex:1}}>
            <Paper>
                <Box sx={{display: "flex", justifyContent: "space-between", flexDirection: "row"}}>
                    <Box sx={{width: "20%"}}>
                        <Button
                            onClick={() => setDate(prev)}>
                            Prev
                        </Button>
                    </Box>
                    <Box sx={{width: "60%", textAlign: "center"}}>
                        <Button endIcon={expansionIcon} onClick={() => setDisplayCalendar(!displayCalendar)}>{dateStr}</Button>
                    </Box>
                    <Box sx={{width: "20%", textAlign: "right"}}>
                        <Button
                            onClick={() => setDate(next)}
                            disabled={date === sixWeeks()}>
                            Next
                        </Button>
                    </Box>
                </Box>
                {displayCalendar && <Box sx={{position: "relative", left: "-20px"}}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                             <DateCalendar
                                 maxDate={dayjs(sixWeeks())}
                                 minDate={dayjs(today())}
                                 value={dayjs(date)}
                                 onChange={(newValue) => {
                                     setDate(newValue.format('YYYY-MM-DD'))
                                     setDisplayCalendar(false)
                                 }}/>
                        </LocalizationProvider>
                </Box>}
                <Divider />
                <Box p={0} style={{textAlign: "center"}}>
                    <AddEventButton date={date} />
                </Box>
            </Paper>
        </Grid>
        <Grid item xs={12}>

                <Box mt={1}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={6}>
                             {events1.map((e,i) =>
                                 <Paper key={i}>
                                    <Box ml={1} mr={1} mb={1}>
                                        <EventCardCompact event={e} />
                                    </Box>
                                </Paper>
                             )}
                        </Grid>
                        <Grid item xs={12} md={6}>
                            {events2.map((e,i) =>
                                <Paper key={i}>
                                    <Box ml={1} mr={1} mb={1}>
                                        <EventCardCompact event={e} />
                                    </Box>
                                </Paper>
                            )}
                        </Grid>
                    </Grid>
                </Box>

        </Grid>
    </Grid>
}

export default DayCalendar